import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Util } from './util';
import { LanguageService } from '../services/language.service';

@Injectable()
export class SubdomainInterceptor implements HttpInterceptor {

  constructor(public util:Util,private languageService: LanguageService) {}
  intercept(request : HttpRequest<any>,next:HttpHandler) : Observable<HttpEvent<any>>{   
    const subdomain = this.util.getSubdomain();
    request = request.clone({
        setHeaders : {
            subdomain: subdomain,
          languageCode:this.languageService.getLanguageCode()

        }            
      });      
  return next.handle(request);
 
}
}
